import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-shipment-address',
  templateUrl: './shipmend-adress.component.html',
  styleUrls: ['./shipmend-adress.component.scss']
})
export class ShipmendAdressComponent implements OnInit {
    @Input() address!: any;
    @Input() label!: string;
    @Input() oneLine!: boolean;
    @Input() minimal!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
